<template>
    <div
        class="flex items-center justify-center text-12/116 text-accent-100 max-md:flex-col">
        Сайт разработан в&nbsp;
        <a
            href="https://www.batyukovstudio.com/"
            target="_blank"
            class="font-bold transition-colors duration-150 hover:text-accent">
            Студии Евгения Батюкова&nbsp;<StudioLogo /> &nbsp;2025
        </a>

        <a
            :href="linkAboutSite"
            target="_blank"
            class="border-ash-200/30 pl-3 font-bold transition-colors duration-150 hover:text-accent max-md:mt-1 max-md:w-full max-md:border-t max-md:pt-1 max-md:text-center md:ml-3 md:border-l">
            Информация о сайте
        </a>
    </div>
</template>

<script setup lang="ts">
import StudioLogo from '~/components/layouts/footer/StudioLogo.vue'

const config = useRuntimeConfig()
const linkAboutSite = computed(() => {
    if (config.public.website == 'cromi.rent')
        return 'https://www.batyukovstudio.com/cromi/development-of-cromi-rent/'
    if (config.public.website == 'radioguide.rent')
        return 'https://www.batyukovstudio.com/cromi/site-radioguide-rent-for-cromi/'
    return 'https://www.batyukovstudio.com/cromi/cromi-ru-2025/'
})
</script>
